<template>
  <div class="mainFence bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('ApplySettings') }} > {{ $t('Electronicfence') }}</div>
    <div class="common-table-cnt common-aside-cnt-top" style="overflow: hidden;">
      <!-- 左侧机构树 -->
      <div class="common-aside">
        <div class="serachLine">
          <el-input :placeholder="$t('nameElectronicFence')" class="serachBarInput" clearable v-model="fenceName">
          </el-input>
          <div :class="[isDefault ? 'searchIcon_d' : 'searchIcon_m']"></div>
          <el-select
            :placeholder="$t('mechanism')"
            style="width: 99px !important;"
            ref="selectReport"
            id="selectReport"
            :popper-append-to-body="false"
            value=""
          >
            <el-option style="width: 260px;height:200px;overflow: auto;" value="">
              <el-tree
                class="select-mechanism common-blue-tree"
                ref="leftFenceTree"
                :data="ouList"
                :default-checked-keys="ouList"
                show-checkbox
                node-key="id"
                :check-strictly="true"
                @check="leftNodeClick"
                :props="defaultProps"
                :default-expand-all="true"
              >
              </el-tree>
            </el-option>
          </el-select>
        </div>
        <el-tree
          :data="treedataList"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          highlight-current
          class="monitorTree"
          ref="dataConfigTree"
          :props="defaultProps"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="node-txt">{{ node.data.name }}</span>
            <span class="editBtn">
              <img src="@/icon/ic_edit.png" class="addicon" @click="clickShowFence(data)" />
            </span>
          </span>
        </el-tree>
      </div>

      <div class="common-aside-main" style="right:15px;">
        <div id="mapFence" ref="mapFence" style="height:100%;width:100%;position: relative">
          <div class="map-switch">
            <div :class="{ active: fenceMap === 'street' }" @click="switchMap('street')">{{ $t('mapB') }}</div>
            <div :class="{ active: fenceMap === 'satellite' }" @click="switchMap('satellite')">
              {{ $t('satellite') }}
            </div>
          </div>
        </div>
        <div class="warn_pan">
          <div :class="[circleObj.editing ? 'warn_left hightLight' : 'warn_left']" @click="toggle('circleObj')">
            <div :class="[isDefault ? 'icon1_online' : 'icon1_online_m']"></div>
            <span>{{ $t('pointFence') }}</span>
          </div>
          <div class="line"></div>
          <div :class="[polylineObj.editing ? 'warn_left hightLight' : 'warn_left']" @click="toggle('polylineObj')">
            <div :class="[isDefault ? 'icon2_warn' : 'icon2_warn_m']"></div>
            <span>{{ $t('lineFence') }}</span>
          </div>
          <div class="line"></div>
          <div :class="[polygonObj.editing ? 'warn_left hightLight' : 'warn_left']" @click="toggle('polygonObj')">
            <div :class="[isDefault ? 'planeFence' : 'planeFence_m']"></div>
            <span>{{ $t('faceFence') }}</span>
          </div>
          <!-- <div class="line"></div>
          <div :class="[polygonObj.editing ? 'warn_left hightLight' : 'warn_left']" @click="setCenter()">
            <div :class="[isDefault ? 'centerFence' : 'centerFence_m']"></div>
            <span>地址搜索</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 新建围栏 -->
    <FenceDialog
      :newFenceFormEdit="newFenceFormEdit"
      :newFenceDialogTableVisible="newFenceDialogTableVisible"
      :newFenceFormEditReadonly="newFenceFormEditReadonly"
      :newFenceForm="newFenceForm"
      :formLabelWidth="formLabelWidth"
      :ouList="ouList"
      :checkedList="newCheckedList"
      :defaultProps="defaultProps"
      :newFenceFormEditSave="newFenceFormEditSave"
      :currEditName="currEditName"
      :polygonObj="polygonObj"
      :polylineObj="polylineObj"
      :circleObj="circleObj"
      :pointDataArr="pointDataArr"
      :initCircleCenter="initCircleCenter"
      :isAppendBody="true"
      :dialogClass="'common-blue-contain'"
      @_geofenceList="_geofenceList"
      @handleClose="handleClose"
      @cancel="cancel"
      @editFence="editFence"
      @editFenceReturn="editFenceReturn"
      @deletFence="deletFence"
      @triggerDiaog="triggerDiaog"
    ></FenceDialog>
    <CenterPointDialog
      :centerPointDialogVisible.sync="centerPointDialogVisible"
      @changePoint="changePoint"
    ></CenterPointDialog>
  </div>
</template>

<script>
import { geofenceList, geofenceDelete, getOus } from '@/api/fence'
import FenceDialog from '@/components/FenceDialog'
import {
  initFenceMap,
  addElectricFenceLayer,
  addPolygonFence,
  addLineStringFence,
  addCircleFence,
  fitFeature,
  enterDrawMode,
  exitDrawMode,
  removeFeatureById,
  setMapCenter,
  switchFenceMapType,
} from '@/common/map'
import CenterPointDialog from '@/components/CenterPointDialog'
import { getSession } from '@/api/common'
import { wgs84_to_gcj02 } from '@/util/wgs84_to_gcj02'
// 地图对象
let fenceMapOl = null
export default {
  data() {
    return {
      // vectorFenceLayer: null, // 电子围栏图层
      // 矢量图层对象
      vectorLayer: null,
      // 绘制模式,若不处于绘制模式则为''
      drawType: '',
      // 绘制中feature id,用于标记删除
      drawingFeatureId: 'drawingFeatureId',
      layers: [], // 地图图层
      mapType: 'normal',
      fenceName: '',
      treedataList: [],
      ouList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      checkedList: [],
      newCheckedList: [],
      isDefault: '',
      zoom: 15,
      theme: '',
      currEditName: 'polygonObj',
      newFenceDialogTableVisible: false,
      newFenceFormEdit: false,
      newFenceFormEditReadonly: true,
      newFenceFormEditSave: false,
      newFenceForm: {
        name: '',
        checkStartTime: '09:00',
        checkEndTime: '18:00',
        eventWarn: '0',
        remark: '',
        pointData: [
          {
            lat: '',
            lng: '',
          },
        ],
        isContact: 0,
        enabled: 0,
        isAttendance: 0,
      },
      userData: {
        selectList: [],
        id: null,
      },
      formLabelWidth: '185px',
      timeLabelWidth: '50px',

      resetData: false,
      recoverData: false,
      polylineObj: {
        isShow: false,
        editing: false,
        paths: [],
        info: '',
      },
      polygonObj: {
        isShow: false,
        editing: false,
        paths: [],
        info: '',
      },
      circleObj: {
        isShow: false,
        editing: false,
        paths: [],
        radius: 500,
        info: '',
      },
      actionDraw: false,
      currentData: '', // 当前选中围栏数据
      pointArr: [],
      pointDataArr: [], // 转换后的坐标
      totalLenght: null,
      initCircleCenter: '', //新建围栏时的中心点
      centerPointDialogVisible: false,
      fenceMap: 'street',
    }
  },
  created() {
    getOus().then(res => {
      if (res.state === 0) {
        this.ouList = res.data
      }
    })
  },
  mounted() {
    let theme = localStorage.getItem('theme')
    this.$nextTick(() => {
      if (this.$store.state.fenceMapType) {
        this.fenceMap = this.$store.state.fenceMapType
      } else if (theme === 'dark') {
        this.fenceMap = 'satellite'
      } else {
        this.fenceMap = 'street'
      }
      this.loadMap()
      switchFenceMapType(this.fenceMap, fenceMapOl)
    })
    if (theme === 'default') {
      this.isDefault = true
    } else {
      this.isDefault = false
    }
  },
  computed: {
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    centerPoint() {
      return JSON.parse(getSession('centerPoint'))
    },
  },
  components: { FenceDialog, CenterPointDialog },
  methods: {
    // 切换地图类型
    switchMap(type) {
      this.fenceMap = type
      this.$store.commit('setfenceMapType', this.fenceMap)
      if (type === 'street') {
        switchFenceMapType('street', fenceMapOl)
      } else {
        switchFenceMapType('satellite', fenceMapOl)
      }
    },
    async loadMap() {
      // 地图风格
      let loctheme = localStorage.theme
      if (loctheme === 'dark') {
        this.theme = 'midnight'
      } else {
        this.theme = 'normal'
      }
      fenceMapOl = await initFenceMap('mapFence')
      this.vectorLayer = addElectricFenceLayer(fenceMapOl)

      this._geofenceList()
      this.currentHelmetLayer = addElectricFenceLayer(fenceMapOl) // 当前点
      // this.vectorFenceLayer = addElectricFenceLayer(fenceMapOl) // 电子围栏图层
      // 点击地图上的电子围栏进行编辑
      fenceMapOl.on('click', e => {
        fenceMapOl.forEachFeatureAtPixel(e.pixel, feature => {
          // 若在绘制模式中则不触发编辑
          console.log(this.drawType)
          if (this.drawType) {
            return
          }
          // 通过id找到最新数据
          let data = this.treedataList.find(o => o.id === feature.getId())
          if (data) {
            this.openFenceInfo(data)
          }
        })
      })
      let center = {
        lng: this.centerPoint.lng,
        lat: this.centerPoint.lat,
      }
      setMapCenter(fenceMapOl, center)
      console.log(this.$store.state.fenceMapType,333)
      if (this.$store.state.fenceMapType) {
        this.fenceMap = this.$store.state.fenceMapType
      }
      switchFenceMapType(this.fenceMap, fenceMapOl)
    },
    changePoint(point) {
      setMapCenter(fenceMapOl, point)
    },
    // 关闭dialog
    triggerDiaog() {
      this.newFenceDialogTableVisible = false
    },

    // 左侧电子围栏树选择类 begin
    leftNodeClick(currentObj, treeStatus) {
      console.log(currentObj, treeStatus)
      // 用于：父子节点严格互不关联时，实现单向关联。
      let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中,>=0为选中
      // 选中
      if (selected !== -1) {
        // 子节点只要被选中父节点就被选中
        this.leftSelectedParent(currentObj)
        // 统一处理子节点为相同的勾选状态
        this.leftUniteChildSame(currentObj, true)
      } else {
        // 未选中 处理子节点全部未选中
        if (currentObj.children !== null) {
          this.leftUniteChildSame(currentObj, false)
        }
      }
      this._geofenceList()
    },
    leftUniteChildSame(treeList, isSelected) {
      this.$refs.leftFenceTree.setChecked(treeList.id, isSelected)
    },
    // 统一处理父节点为选中
    leftSelectedParent(currentObj) {
      let currentNode = this.$refs.leftFenceTree.getNode(currentObj)
      if (currentNode.parent.key !== undefined) {
        this.$refs.leftFenceTree.setChecked(currentNode.parent, true)
        this.leftSelectedParent(currentNode.parent)
      }
    },
    // 左侧电子围栏树选择类 end
    handleClose() {
      if (this.newFenceFormEdit === false) {
        this.cancel()
      }
      this.editFenceReturn()
      this.newFenceDialogTableVisible = false
    },
    // 返回编辑查看页面
    editFenceReturn() {
      console.log(this.newFenceFormEdit,'返回编辑查看页面')
      // 恢复编辑前数据
      this.newFenceForm = JSON.parse(JSON.stringify(this.currentData))
      this.newCheckedList = JSON.parse(JSON.stringify(this.checkedList))
      this.newFenceFormEditSave = false
      this.newFenceFormEditReadonly = true
    },
    // 修改围栏
    editFence() {
      this.newFenceFormEditSave = true
      this.newFenceFormEditReadonly = false
    },
    // 删除围栏
    deletFence() {
      this.$confirm(this.$t('deleteTheFence'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      })
        .then(() => {
          let paramId = {
            geofenceId: this.currentData.id,
          }
          geofenceDelete(paramId).then(res => {
            this.$message({
              message: this.$t('deleteSuccess'),
              type: 'success',
            })
            this.newFenceDialogTableVisible = false
            fitFeature(fenceMapOl, this.vectorLayer)
            this._geofenceList()
            removeFeatureById(this.vectorLayer, this.currentData.id)
          })
        })
        .catch(() => {})
    },
    // 获取围栏列表
    _geofenceList() {
      removeFeatureById(this.vectorLayer, this.drawingFeatureId)
      let idArr = []
      if (this.$refs.leftFenceTree) {
        let NodesArr = this.$refs.leftFenceTree.getCheckedNodes()
        for (let item of NodesArr) {
          idArr.push(item.id)
        }
      }
      let param = {
        name: this.fenceName,
        ouIds: idArr,
      }
      geofenceList(param).then(res => {
        // 左侧电子围栏赋值
        this.treedataList = res.data
        this.treedataList.forEach(item => {
          item.pointData = JSON.parse(item.pointData)
        })
        setTimeout(() => {
          this.showFence()
        }, 200)
      })
    },
    // 展示电子轨迹
    showFence() {
      if (this.treedataList) {
        this.treedataList.forEach(item => {
          // 点围栏
          if (item.type === 0) {
            if (item.pointData[0]) {
              var newPoint
              if (process.env.VUE_APP_MAP_GWS_TO_GC !== 'wgs84_to_gcj02') {
                newPoint = wgs84_to_gcj02(item.pointData[0].lng, item.pointData[0].lat)
              } else {
                newPoint = [item.pointData[0].lng, item.pointData[0].lat]
              }
              addCircleFence(
                this.vectorLayer,
                item,
                [newPoint[0], newPoint[1]],
                // 单位需要进行转换，减小100000倍为地图半径
                item.range / 1000 / 100
              )
            }
          } else {
            let points = []
            item.pointData.forEach(item => {
              let lnglatPoint
              if (process.env.VUE_APP_MAP_GWS_TO_GC !== 'wgs84_to_gcj02') {
                lnglatPoint = wgs84_to_gcj02(item.lng, item.lat)
              } else {
                lnglatPoint = [item.lng, item.lat]
              }

              points.push([lnglatPoint[0], lnglatPoint[1]])
            })
            // 线围栏
            if (item.type === 1) {
              addLineStringFence(this.vectorLayer, item, points)
            }
            // 面围栏
            else if (item.type === 2) {
              addPolygonFence(this.vectorLayer, item, points)
            }
          }
        })
      }
    },
    // 电子围栏编辑弹窗
    openFenceInfo(data) {
      console.log(data,'电子围栏编辑弹窗')
      if (data.type === 2) {
        this.currEditName = 'polygonObj'
      } else if (data.type === 1) {
        this.currEditName = 'polylineObj'
      } else if (data.type === 0) {
        this.currEditName = 'circleObj'
      }

      this.checkedList = []
      let ouArr = data.ouIds
      if (ouArr) {
        ouArr.forEach(item => {
          this.checkedList.push(item)
        })
      }
      this.newFenceFormEditReadonly = true
      this.newFenceFormEdit = true
      this.newFenceDialogTableVisible = true
      this.currentData = data
      this.newFenceForm = JSON.parse(JSON.stringify(data))
      this.newCheckedList = JSON.parse(JSON.stringify(this.checkedList))
    },
    // 取消新增
    cancel() {
      // 移除最后一次绘制的图形
      removeFeatureById(this.vectorLayer, this.drawingFeatureId)
      this.drawType = ''
      this.newFenceDialogTableVisible = false
    },
    handleNodeClick(data) {
      this.showFence()
      // 点击左侧电子围栏节点，地图自适应对应电子围栏位置
      fitFeature(fenceMapOl, this.vectorLayer, data.id)
    },
    // 直接展示电子围栏
    clickShowFence(data) {
      console.log(data,"clickShowFence-data");
      this.showFence()
      // 点击左侧电子围栏节点，地图自适应对应电子围栏位置
      fitFeature(fenceMapOl, this.vectorLayer, data.id)
      //打开编辑弹窗
      this.openFenceInfo(data)
    },
    zoomEnd(e) {
      this.zoom = e.target.getZoom()
    },
    setCenter() {
      this.centerPointDialogVisible = true
    },
    toggle(drawType) {
      if (this.drawType === drawType) {
        // 如果已在绘制模式，则取消绘制
        this.$message({
          message: this.$t('cancelFenceDrawing'),
          type: 'info',
        })
        this.drawType = ''
        exitDrawMode(fenceMapOl)
      } else {
        // 进入绘制模式
        this.currEditName = drawType
        this.drawType = drawType
        this.$message({
          message: this.$t('clickTheMap'),
          type: 'warning',
        })
        // 页面配置名称与实际绘制类型字符串转换  eg: circleObj -> Circle
        let drawTypeTrans = {
          circleObj: 'Circle',
          polylineObj: 'LineString',
          polygonObj: 'Polygon',
        }
        if (drawTypeTrans[drawType]) {
          enterDrawMode(fenceMapOl, this.vectorLayer, drawTypeTrans[drawType], this.drawendHandle)
        }
      }
    },
    // 绘制完成后打开新增电子围栏弹窗
    drawendHandle(e) {
      let feature = e.feature
      // 将最新的一个feature id设置为固定值，方便在取消时删除
      feature.setId(this.drawingFeatureId)
      let geometry = feature.getGeometry()
      let type = geometry.getType()
      let W84Arr = []
      // 重置新增表单值
      console.log(type,'type新增电子围栏弹窗')
      this.newFenceForm = {
        name: '',
        checkStartTime: '09:00',
        checkEndTime: '18:00',
        eventWarn: '0',
        remark: '',
        pointData: [
          {
            lat: '',
            lng: '',
          },
        ],
        isContact: 0,
        enabled: 0,
        isAttendance: 0
      }
      if (type === 'Circle') {
        // 圆形绘制得到圆心和半径
        let center = geometry.getCenter()
        let radius = geometry.getRadius()
        W84Arr = [{ lat: center[1], lng: center[0] }]
        // 圆只保留最后一个点
        this.initCircleCenter = JSON.parse(JSON.stringify(W84Arr[0]))
        // 单位需要进行转换，增大100000倍后单位为米 (radius * 100 * 1000)
        this.newFenceForm.range = (radius * 100 * 1000).toFixed(2)
      } else {
        let coordinates = geometry.getCoordinates()
        if (coordinates == null) {
          return
        }
        // Polygon数据会嵌套双层数组，减少一层后与LineString格式保持一致  eg: [[[93,23]]] -> [[93,23]]
        if (type === 'Polygon') {
          coordinates = coordinates[0]
        }
        coordinates.forEach(element => {
          W84Arr.push({ lat: element[1], lng: element[0] })
        })
      }
      this.checkedList = []
      this.pointDataArr = W84Arr
      // console.log(this.pointDataArr,'绘制完成后')
      this.newFenceDialogTableVisible = true
      this.newFenceFormEdit = false
      this.newFenceFormEditReadonly = false
      this.newCheckedList = []
      // 绘制完成后才清空类型
      setTimeout(() => {
        this.drawType = ''
      }, 1)
    },
  },
  watch: {
    getTheme(val) {
      this.theme = val
      this.$nextTick(() => {
        if (val === 'dark') {
          switchFenceMapType('satellite', fenceMapOl)
          this.fenceMap = 'satellite'
        } else {
          switchFenceMapType('street', fenceMapOl)
          this.fenceMap = 'street'
        }
        this.$store.commit('setfenceMapType', this.fenceMap)
      })

      if (this.theme === 'default') {
        this.isDefault = true
      } else if (this.theme === 'dark') {
        this.isDefault = false
      }
    },
    fenceName(val) {
      this._geofenceList()
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/new-set-common.styl'
#selectReport
  >>>.el-popper{
    width 100% !important
  }
.mainFence
  // height 100%
  .monitorTree
    overflow auto
    height 92%
  .serachLine
    margin 10px
    display flex
    align-items center
    .line
      width 1px
      height 22px
      display inline-block
    .serachBarInput
      margin-right: 5px;
      width 170px
    >>>.el-input__inner
      border none
      height 36px;/*no*/
      line-height 36px;/*no*/
    .searchIcon_d
      position: absolute;
      left: 195px;
      z-index: 999;
      width 17px
      height 17px
      bg-image('~@/icon/search.png')
    .searchIcon_m
      position: absolute;
      left: 195px;
      z-index: 999;
      width 17px
      height 17px
      bg-image('~@/icon/search_m.png')
  .map-switch
    position: absolute;
    background: white;
    z-index: 1;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    left: 70px;/*no*/
    top: 10px;/*no*/

    div
      box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(139, 164, 220);
      background: rgb(255, 255, 255);
      border-radius: 4px;
      padding: 2px 6px;/*no*/
      font-style: normal;
      font-variant: normal;
      font-stretch: normal;
      font-size: 12px;
      line-height: 1.3em;/*no*/
      font-family: arial, sans-serif;
      text-align: center;
      white-space: nowrap;
      color: rgb(0, 0, 0);
      float left
      &.active
        box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
        border-left: 1px solid rgb(139, 164, 220);
        border-top: 1px solid rgb(139, 164, 220);
        border-bottom: 1px solid rgb(139, 164, 220);
        background: rgb(142, 168, 224);
        padding: 2px 6px;/*no*/
        font: bold 12px / 1.3em arial, sans-serif;
        text-align: center;
        white-space: nowrap;
        color: rgb(255, 255, 255);
  .warn_pan
    padding 9px 11px
    display flex
    position absolute
    right 18px
    top 15px
    box-shadow 0px 3px 4px 0px rgba(0, 0, 0, 0.1)
    border-radius 4px
    .warn_left
      display flex
      align-items center
      cursor pointer
      span
        font-weight bold
        font-size 15px
      .icon1_online
        width 30px
        height 30px
        bg-image('~@/icon/circle.png')
        background-size 100%
      .icon1_online_m
        width 30px
        height 30px
        bg-image('~@/icon/circle_m.png')
        background-size 100%
      .icon2_warn
        width 30px
        height 30px
        bg-image('~@/icon/lineFence.png')
        background-size 100%
      .icon2_warn_m
        width 30px
        height 30px
        bg-image('~@/icon/lineFence_m.png')
        background-size 100%
      .planeFence
        width 30px
        height 30px
        bg-image('~@/icon/planeFence.png')
        background-size 100%
      .planeFence_m
        width 30px
        height 30px
        bg-image('~@/icon/planeFence_m.png')
        background-size 100%
      .centerFence
        width 30px
        height 30px
        bg-image('~@/icon/place_search.png')
        background-size 100%
      .centerFence_m
        width 30px
        height 30px
        bg-image('~@/icon/place_m.png')
        background-size 100%
    .line
      width 1px
      height 30px
      margin 0 15px
    .disable
      pointer-events none
  .hightLight
    background var(--fence-drawTool-bg)
    border-radius: 8px;
  .el-select-dropdown__item.selected
    font-weight: normal!important;
   >>>.el-tree-node__label
    width 90%
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    text-align: left;
.custom-tree-node
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 0.10416667rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
.node-txt
  font-size 16px;/*no*/
>>>.el-tree-node__content:hover .editBtn
  display inline-block
.editBtn
  display none
  .addicon
    margin-right 10%
    width 20px
    height 20px
>>>.ol-zoom
  left: 10px !important;/*no*/
  top: 10px !important;
</style>
